/**
 * Customer-facing public host for landing pages, review gates, and card links.
 * ZenSocial must use the white-label domain (u.reviewour.biz), never app.zensocial.io.
 */
export function isZenSocialPublicHost() {
  return typeof window !== 'undefined' && window.location.origin.includes('zensocial.io');
}

export function publicCustomerBaseUrl() {
  if (typeof window === 'undefined') {
    return 'https://app.showmyrep.io';
  }
  const origin = window.location.origin;
  if (origin.includes('staging.')) {
    return 'https://staging.replyengine.io';
  }
  if (origin.includes('zensocial.io')) {
    return 'https://u.reviewour.biz';
  }
  return 'https://app.showmyrep.io';
}

export function reviewGatePublicBaseUrl() {
  return `${publicCustomerBaseUrl()}/r/`;
}

export function reviewGatePublicUrl(uniqueId) {
  return `${reviewGatePublicBaseUrl()}${uniqueId || ''}`;
}

export function publicLandingBaseUrl() {
  return `${publicCustomerBaseUrl()}/p/`;
}

export function publicCardBaseUrl() {
  return `${publicCustomerBaseUrl()}/c/`;
}
